import { render } from "./KontaktView.vue?vue&type=template&id=0c02c6df"
import script from "./KontaktView.vue?vue&type=script&lang=js"
export * from "./KontaktView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__